import { useContext } from "react";
import { I18nContext } from "./../utilities/I18nContext";
import { DateRange } from "./DateRangePicker";
import TextField, { TextFieldProps } from "./TextField";

type DateRangeFieldProps = Omit<TextFieldProps, "onChange" | "value"> & {
  dateRange: DateRange;
};

function DateRangeField({ dateRange, ...rest }: DateRangeFieldProps) {
  const i18n = useContext(I18nContext);
  const formattedDateRange = i18n.formatDateRange(dateRange, { format: "dateUtc", divider: "to" });

  return <TextField value={formattedDateRange} {...rest} />;
}

export default DateRangeField;
